/**
 * @todo Удалить директорию полностью
 * @description Данный функционал появился в задаче CD-194493, будет удалён в задаче CD-194545
 */

import * as React from 'react';
import { IconClose16 } from '@cian/ui-kit';
import { ISimplifieldTGBBannerContext } from '../../../types/adfox';
import { ScrollFade } from '../../ScrollFade';
import { GoToButton } from '../GoToButton';
import { Metro } from '../Metro';
import * as styles from './styles.css';

export interface INativeTGBNormalDescriptionProps {
  context: ISimplifieldTGBBannerContext;
  locationId: number | undefined;
}

/*
 * Нативный ТГБ Вариант 2: с обычным описанием, максимальная нативность
 */
export function NativeTGBNormalDescription({ context, locationId }: INativeTGBNormalDescriptionProps) {
  const [isClosed, setClosedState] = React.useState(false);

  const onClose = React.useCallback(() => {
    setClosedState(true);
  }, []);

  if (isClosed) {
    return <div className={styles['empty']} data-testid="empty_native_adfox_block" />;
  }

  const {
    title,
    location,
    description,
    annotation,
    imageURL,
    image,
    metro,
    reference,
    site,
    url,
    metroDistance,
    metroColor,
    button,
    label,
  } = context;

  return (
    <div className={styles['container']} data-testid="adfox_native_normal_description">
      <a href={reference || url} target="_blank" className={styles['main-link']} rel="noreferrer">
        <div className={styles['photo-container']}>
          {label && <span className={styles['ad-label']}>{label}</span>}
          <img className={styles['photo']} src={imageURL || image} />
        </div>
        <div className={styles['main-content']}>
          <div className={styles['title']}>{title}</div>
          <div className={styles['address-container']}>
            {metro && (
              <Metro metro={metro} metroDistance={metroDistance} locationId={locationId} metroColor={metroColor} />
            )}
            <div className={styles['address']}>{location}</div>
          </div>
          <div className={styles['description']}>{description}</div>
          <div className={styles['links-container']}>
            <div className={styles['goto-button-container']}>
              <GoToButton buttonText={button} />
            </div>
            <div className={styles['link-view']}>{site}</div>
          </div>
        </div>
        <div className={styles['aside']}>
          <div className={styles['ad-info']}>
            {annotation}
            <ScrollFade size={12} />
          </div>
        </div>
      </a>
      <button className={styles['close']} aria-label="Закрыть" onClick={onClose}>
        <IconClose16 />
      </button>
    </div>
  );
}
